<template>
    <div class="reo-plan-message">
        <div class="message" v-for="(item, index) in list" :key="index">
            <div class="label">{{ item.label }}:</div>
            <div :class="{
                red: item.red
            }">
                <p v-for="(text, i) in item.texts" :key="i">
                    {{ text }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { IPlanMessage } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';

export default Vue.extend({

    props: {

        list: Array as PropType<IPlanMessage[]>

    }

});
</script>

<style scoped lang="less">
.reo-plan-message{
    padding: 14px 25px;
    background-color: @bg_01;
    font-size: 16px;
    border-radius: @border-radius-level-button;
    @media @mobile{
        padding: 16px;
        font-size: 14px;
    }
    .label{
        font-weight: 500;
        line-height: 19px;
        padding-right: 12px;
        white-space: nowrap;
        color: @font_secondary;
        @media @mobile{
            padding-right: 0.6rem;
        }
    }
    tr+tr td{
        padding-top: 11px;
    }
    tr{
        text-align: left;
        vertical-align: top;
    }
    
    p{
        word-wrap: break-word;
        line-height: 19px;
    }
    .message{
        @media @pc{
            display: flex;
        }
    }
    
    .message:not(:first-child){
        margin-top: 11px;
    }
}
</style>
